import {ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';

@Component({
    selector: 'app-module-item',
    templateUrl: './module-item.component.html',
    styleUrls: ['./module-item.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ModuleItemComponent implements OnInit {
    @Input() module;
    @Output() onDataChange = new EventEmitter<any>();

    constructor() {
    }

    ngOnInit() {
    }

    /**
     * Emit event after value change...
     */
    onChangeOption(config, value, code, module) {
        this.module[config].unit_quantity = value;
        this.onDataChange.emit({code: code || this.module.code, config: config, value: value});
    }

    /**
     * Called after input field changes...
     */
    onChangeInput(config) {
        this.onDataChange.emit({code: this.module.code, config: config, value: this.module[config].unit_quantity});
    }

    /**
     * Emit events from recursive child...
     */
    recursiveUpdate(event) {
        this.onDataChange.emit({code: event.code, config: event.config, value: event.value});
    }
}



// WEBPACK FOOTER //
// /Users/dominik/Documents/projekty/guru-apps-saas/src/app/shared/module-item/module-item.component.ts